/**
 * The words of the HR screens review of 2026-10-04 that were still open in pm on 2026-10-07
 * (part C). Kept beside the catalogue, as the other HR rounds' words are, and spread into it.
 */
export const HR_PM_C_EN = {
    // human-resources-psgb6djz: what each of the two Nitaqat buttons does.
    "gov_sa.nitaqat.ratio.action.refresh.effect": "Reads each employee's nationality, wage, status and contract attestation from HR again, then computes the ratio from them.",
    "gov_sa.nitaqat.ratio.action.compute.effect": "Computes the ratio from what is already here, without asking HR, and records it for today even when it has not moved.",
};
export const HR_PM_C_AR = {
    "gov_sa.nitaqat.ratio.action.refresh.effect": "يقرأ من الموارد البشرية من جديد جنسية كل موظّف وأجره وحالته وتوثيق عقده، ثم يحسب النسبة منها.",
    "gov_sa.nitaqat.ratio.action.compute.effect": "يحسب النسبة مما هو مسجَّل هنا دون الرجوع إلى الموارد البشرية، ويقيّدها لليوم ولو لم تتغيّر.",
};
//# sourceMappingURL=i18n-hr-pm-c.js.map